export default __webpack_public_path__ + "static/media/bg_metiers.ae0d4167.jpeg";